import React from 'react';
import { CheckCircle2, Play, Book, FileText, Download } from 'lucide-react';
import { Button } from '../ui/button';

interface CourseProgressProps {
  completedLessons: number;
  totalLessons: number;
  duration: string;
  modulesCount: number;
  onSyllabusDownload: () => void;
  onAllMaterialsDownload: () => void;
  onStartAssessment: () => void;
}

export const CourseProgress: React.FC<CourseProgressProps> = ({
  completedLessons,
  totalLessons,
  duration,
  modulesCount,
  onSyllabusDownload,
  onAllMaterialsDownload,
  onStartAssessment
}) => {
  return (
    <div className="lg:w-1/3">
      <div className="bg-white rounded-xl shadow-md p-6 border border-gray-200 sticky top-20">
        <h3 className="text-lg font-semibold mb-4">Course Progress</h3>
        
        <div className="space-y-4 mb-6">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-2">
              <CheckCircle2 size={18} className="text-green-500" />
              <span>Completed Lessons</span>
            </div>
            <span className="font-medium">{completedLessons}/{totalLessons}</span>
          </div>
          
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-2">
              <Play size={18} className="text-primary" />
              <span>Total Video Content</span>
            </div>
            <span className="font-medium">{duration}</span>
          </div>
          
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-2">
              <Book size={18} className="text-primary" />
              <span>Total Modules</span>
            </div>
            <span className="font-medium">{modulesCount}</span>
          </div>
        </div>
        
        <div className="pt-4 border-t border-gray-200">
          <h4 className="font-medium mb-3">Course Resources</h4>
          <div className="space-y-2">
            <Button 
              variant="outline" 
              className="w-full justify-start hover:bg-[#0071bd]"
              onClick={onSyllabusDownload}
            >
              {/* <FileText size={16} className="mr-2" /> */}
              <Download size={16} className="mr-2" />
              Course Syllabus
            </Button>
            <Button 
            disabled={true}
              variant="outline" 
              className="w-full justify-start hover:bg-[#0071bd]"
              onClick={onAllMaterialsDownload}
            >
              <Download size={16} className="mr-2" />
              Download All Materials
            </Button>
            <Button 
              className="w-full justify-start mt-4 bg-primary hover:bg-primary/90"
              onClick={onStartAssessment}
            >
              <FileText size={16} className="mr-2" />
              Start Assessment
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
